<ef-indirect-rate-review-presenter
    [items]="IndirectRateReviewModel$ | async"
    [loading]="IndirectRateReviewModelDS.loading$ | async"
    [messages]="MessagesSubject.asObservable() | async"
    (Cancel)="onCancel()"
    (Commit)="onCommit()"
></ef-indirect-rate-review-presenter>
